/**
 * Created by jonas on 2021-02-02.
 */

import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IOktoberfestGameData, IOktoberfestInitData, IBetLineWinData} from "./data/IOktoberfestData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {StateMatrix} from "../../core/utils/StateMatrix";
import {OktoberfestParsedInitData} from "./data/OktoberfestParsedInitData";
import {OktoberfestParsedGameData} from "./data/OktoberfestParsedGameData";
import {OktoberfestDataParser} from "./data/OktoberfestDataParser";
import {OktoberfestSymbolState} from "../symbol/OktoberfestSymbolConfig";

export class OktoberfestModel extends GameModel<IOktoberfestInitData, IOktoberfestGameData> {

    public parsedInitData:OktoberfestParsedInitData;
    public parsedGameData:OktoberfestParsedGameData;
    public reels:string[][];
    public isRestore:boolean = false;

    private _parser:OktoberfestDataParser;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
        this._parser = new OktoberfestDataParser();
    }

    protected onInit(data:IOktoberfestInitData):void {
        this.parsedInitData = new OktoberfestParsedInitData(data, this._parser);
        this.reels = this.parsedInitData.reels;
        this.isRestore = data.isRestoreState;
        super.onInit(data);
    }

    protected onGame(data:IOktoberfestGameData):void {
        this.parsedGameData = new OktoberfestParsedGameData(data, this._parser);
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        super.onGame(data);
    }
}